<header>
  <app-header></app-header>
</header>
<div class="wrapper">
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>